<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Datos del Tipo de Artículo">
            <b-table 
                small 
                responsive="sm" 
                :busy="tableBusy"
                :items="articuloTipoDatos" 
                :fields="campos">
              <template v-slot:cell(valor)="data">
                {{ formattedData(data.item) }}
              </template>
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>              
            </b-table>
        </b-card>
      </b-col>
    </b-row>
    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="editar">
            <i class="fa fa-edit"></i>Editar Datos del Tipo de Artículo</b-dropdown-item>

          <b-dropdown-item @click.stop="goBack">
            <i class="fa fa-undo"></i>Volver al Listado</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'articuloTipo/getField',
  mutationType: 'articuloTipo/updateField',
});

export default {
  name: 'ArticuloTipoData',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data: () => {
    return {
      id: 0,
      campos: [
        {key: 'campo'},
        {key: 'valor'},
      ],

      tableBusy: false,
    }
  },
  created() {
    this.id= this.$route.params.id
    
    this.tableBusy = true;
    this.$store.dispatch('articuloTipo/getDatos', this.id)
      .then(() => this.tableBusy = false)
      .catch(error => this.showErrorMsj(error));
  },  
  computed: {
    ...mapFields([
      'articuloTipoDatos',
    ]),
  },  
  methods: {
    goBack() {
      this.$router.push({ name: 'ArticulosTipos' }); 
    },
    editar() {
      this.$router.push({ name: 'ArticuloTipoABM', 
                          params: { id: this.id }})
    },
  }
}
</script>
